import axios from "axios";
const instance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	headers: {
		"Content-Type": "application/json",
		Authorization: JSON.parse(window.localStorage.getItem("token")) || null,
	},
});

const get = (uri, params, successCallback, failureCallback) => {
	instance
		.get(uri, params)
		.then((response) => {
			if (response.status === 401) {
				window.location.href = "/login";
			} else {
				return successCallback(response.data);
			}
		})
		.catch((err) => {
			console.log(uri);
			console.log(err);
			return failureCallback(err);
		});
};

const post = (uri, data, successCallback, failureCallback) => {
	instance
		.post(uri, data)
		.then((response) => {
			if (response.status === 401) {
				window.location.href = "/login";
			} else if (response.status >= 400) {
				if (failureCallback) return failureCallback(response);
			} else {
				return successCallback(response.data);
			}
		})
		.catch((err) => {
			console.log(uri);
			console.log(err);
			if (failureCallback) return failureCallback(err);
		});
};

const patch = (uri, data, successCallback, failureCallback) => {
	instance
		.patch(uri, data)
		.then((response) => {
			if (response.status === 401) {
				window.location.href = "/login";
			} else if (response.status >= 400) {
				if (failureCallback) return failureCallback(response);
			} else {
				return successCallback(response.data);
			}
		})
		.catch((err) => {
			if (failureCallback) return failureCallback(err);
		});
};

const exported = { get, post, patch };
export default exported;
